import { FilterFixed, useFilterDataHook } from '@op/components/FilterCommon';
import { DBO_TM } from '@op/utils/format';
import React, { useMemo, useRef, useState } from 'react';
import OverviewMetrics from './OverviewMetrics';
import { IRealtimeOpinionsTabType, IRealtimeOpinions } from '../../type';
import CardLoading from '@op/components/CardLoading';
import './index.scss';
import AddedKeyword from './AddedKeyword';
import Steam from './Steam';
import Community from './Community';
import Feeds from './Feeds';
import { AppContext } from './context';
import { useRealtimeRefresh } from '../../hook'; 

const KeyMetricsOverview = (props: IRealtimeOpinions) => {
  const { gameInfo, wholeGameInfo, onActive } = props;
  const {
    scrollBody,
    loading,
    filter,
    changeFilter,
    filterOptions,
    confirmRef,
  } = useFilterDataHook({
    gameInfo,
    pageName: "Key_Metrics",
  });

  const [deadline, setDeadline] =
    useState<IRealtimeOpinionsTabType>('current');
  const [endTime, setEndTime] = useState('');
  const isToday = useMemo(() => !loading ? DBO_TM.isToday(filter) : false, [filter, loading]);
  const { refresh, setRefresh, resetInterval, refreshTime, setRefreshTime } = useRealtimeRefresh(isToday);

  return (
    <div className="dbo-key-metrics-overview-wrapper">
      <FilterFixed
        scrollBody={scrollBody}
        filter={filterOptions}
        confirmRef={confirmRef}
        defaultValue={{
          ...DBO_TM.utcFilterRangeDay(0, 0),
          date_type: 'daily'
        }}
        confirm={(value: any) => {
          changeFilter({ ...value, ...gameInfo });
          resetInterval();
        }}
        defaultConfig={{
          date: {
            isSingleDay: true,
          },
        }}
      ></FilterFixed>
      <CardLoading loading={loading}>
        <AppContext.Provider value={{ refresh, setRefresh, refreshTime, setRefreshTime }}>
          <OverviewMetrics
            value={deadline}
            setValue={setDeadline}
            filter={filter}
            gameInfo={gameInfo}
            wholeGameInfo={wholeGameInfo}
            setEndTime={setEndTime}
          />
          <AddedKeyword
            deadline={deadline}
            filter={filter}
            gameInfo={gameInfo}
          ></AddedKeyword>
          <Steam
            filter={filter}
            gameInfo={gameInfo}
            wholeGameInfo={wholeGameInfo}
            deadline={deadline}
          />
          <Community
            filter={filter}
            gameInfo={gameInfo}
            deadline={deadline}
            onActive={onActive}
          />
          <Feeds filter={filter} gameInfo={gameInfo} endTime={endTime} deadline={deadline} />
        </AppContext.Provider>
      </CardLoading>
    </div>
  );
};

export default KeyMetricsOverview;
